import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-167eb89a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-external"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_FriedH5 = _resolveComponent("FriedH5");
    const _component_DetachedCommentAnchor = _resolveComponent("DetachedCommentAnchor");
    const _component_EditorSection = _resolveComponent("EditorSection");
    return (_openBlock(), _createElementBlock("div", {
        ref: "editorContainer",
        class: _normalizeClass(['editor-block', _ctx.blockWidthClass, { 'is-dsr': _ctx.isDsr }])
    }, [
        (_ctx.showCommentsBlockedBanner)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "comments-locked",
                "data-external": `block-cc-locked-page-id:${_ctx.blockId}`
            }, [
                _createVNode(_component_FriedIcon, { icon: "comments-locked" }),
                _createVNode(_component_FriedH5, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('cc_eas_block_is_being_edited_banner')), 1)
                    ]),
                    _: 1
                })
            ], 8, _hoisted_1))
            : _createCommentVNode("", true),
        (!_ctx.isDsr)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.firstRowContainsCoverImage ? 'block' : 'block-padding')
            }, null, 2))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsWithoutSectionId, (comment) => {
            return (_openBlock(), _createBlock(_component_DetachedCommentAnchor, {
                id: comment.id,
                key: comment.id
            }, null, 8, ["id"]));
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSections, (section) => {
            return (_openBlock(), _createBlock(_component_EditorSection, {
                key: section.id,
                "section-id": section.id,
                "is-hidden": section.hidden,
                context: _ctx.context,
                "focused-required-id": _ctx.focusedRequiredId,
                rows: section.rows,
                "merge-values": _ctx.mergeValues,
                "allowed-to-edit-after-partially-signed": _ctx.allowedToEditAfterPartiallySigned,
                "is-dsr": _ctx.isDsr,
                "is-preview": _ctx.isPreview,
                "is-pdf-viewer": _ctx.isPdfViewer,
                "block-width-class": _ctx.blockWidthClass,
                "page-width": _ctx.blockOffsetWidth,
                theme: _ctx.theme,
                "is-block-toggled": _ctx.isBlockToggled,
                sender: _ctx.sender,
                recipient: _ctx.recipient,
                "recipient-input": _ctx.recipientInput,
                "pusher-client": _ctx.pusherClient,
                "partially-signed-fields": _ctx.partiallySignedFields,
                "updating-inputs": _ctx.updatingInputs,
                "failed-input-updates": _ctx.failedInputUpdates,
                comments: _ctx.filterCommentsBySection(_ctx.comments, section.id),
                "selected-comment-id": _ctx.selectedCommentId,
                "show-contextual-comments": _ctx.showContextualComments,
                "create-contextual-comment-button-state": _ctx.createContextualCommentButtonState,
                "current-user": _ctx.currentUser,
                "linked-contracts": _ctx.linkedContracts,
                "mapped-placeholders": _ctx.mappedPlaceholders,
                onNodeClick: ($event) => (_ctx.$emit('node-click', Object.assign(Object.assign({}, $event), { sectionId: section.id }))),
                onUpdateInputValue: _ctx.handleUpdateInputValue,
                onTrackVideo: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('track-video', $event))),
                onObserveNodeVisibility: ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { sectionId: section.id }))),
                onUpdateElementVisibility: ($event) => (_ctx.$emit('observe-section-visibility', Object.assign(Object.assign({}, $event), { sectionId: section.id }))),
                onPartiallySign: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('partially-sign', $event))),
                onCreateComment: ($event) => (_ctx.$emit('create-comment', Object.assign(Object.assign({}, $event), { sectionId: section.id }))),
                onSelectComment: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('select-comment', $event))),
                onFetchNewImage: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('fetch-new-image', Object.assign(Object.assign({}, $event), { contentId: _ctx.content.id }))))
            }, null, 8, ["section-id", "is-hidden", "context", "focused-required-id", "rows", "merge-values", "allowed-to-edit-after-partially-signed", "is-dsr", "is-preview", "is-pdf-viewer", "block-width-class", "page-width", "theme", "is-block-toggled", "sender", "recipient", "recipient-input", "pusher-client", "partially-signed-fields", "updating-inputs", "failed-input-updates", "comments", "selected-comment-id", "show-contextual-comments", "create-contextual-comment-button-state", "current-user", "linked-contracts", "mapped-placeholders", "onNodeClick", "onUpdateInputValue", "onObserveNodeVisibility", "onUpdateElementVisibility", "onCreateComment"]));
        }), 128)),
        (!_ctx.isDsr)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(_ctx.lastRowContainsCoverImage ? 'block' : 'block-padding')
            }, null, 2))
            : _createCommentVNode("", true)
    ], 2));
}
